import { VARIABLE_NAMES } from "../variable-constants";
import { SettingsConfig } from "../settings-type";

const tour: Partial<SettingsConfig> = {
  [VARIABLE_NAMES.VARIABLE_TO_TEST_WITH]: "tour",
  [VARIABLE_NAMES.FAVICON_COLOR]: "green",
};

export default tour;
